import React from "react";
import FadeIn from "../components/FadeIn";

export default function About({ lang, t }) {
  return (
    <section id="about" className="relative w-full min-h-screen bg-zinc-100 font-sans py-16 md:py-24 px-6 md:px-12 flex flex-col justify-between border-b border-zinc-200">
      {/* Top Section: Right-Aligned Date Label */}
      <div className="absolute top-6 right-6 md:top-10 md:right-10 text-xs text-zinc-400 tracking-[0.2em] font-bold uppercase select-none mb-6 md:mb-0">
        {t("about.established")}
      </div>

      <FadeIn className="max-w-7xl mx-auto w-full my-auto space-y-8 md:space-y-12">
        {/* Middle Grid: Text Content vs. Brand Card */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          {/* Left Column: Primary Copy */}
          <div className="lg:col-span-8 flex flex-col gap-4 max-w-3xl">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-brand-navy leading-tight tracking-tight font-display pt-8 md:pt-0">
              {t("about.introTitle")}
            </h2>
            <div className="h-1 w-16 bg-brand-orange"></div>
            <div className="text-zinc-600 space-y-4 leading-relaxed font-light text-sm md:text-base">
              <p className="border-l-2 border-brand-blue/30 pl-4 italic text-zinc-700">
                {lang === "da"
                  ? "Albertsen Group, LLC opererer i krydsfeltet mellem akademisk stringens og næste generations kunstige intelligens. Som et førende holdingselskab fokuserer vi på at finansiere, designe og avancerede vidensstyringsplatforme, der tjener forskere og universiteter verden over."
                  : "Albertsen Group, LLC operates at the intersection of academic rigor and next-generation artificial intelligence. As a premier holding company, we focus on funding, designing and advanced knowledge management platforms that serve researchers and universities worldwide."}
              </p>
              <p>{t("about.subsidiaryText")}</p>
              <p>{t("about.officeText")}</p>
            </div>
          </div>

          {/* Right Column: Solid Brand Surface */}
          <div className="lg:col-span-4 flex justify-center lg:justify-end">
            <div className="bg-white w-48 h-48 p-4 flex flex-col items-center justify-center rounded-none shadow-md border border-zinc-200 relative select-none">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/25c88f45-a091-4778-ada1-e41c6b1f66ac/image.png"
                alt="Albertsen Group Logo Emblem"
                width="192"
                height="192"
                loading="lazy"
                className="absolute inset-2 w-[calc(100%-16px)] h-[calc(100%-16px)] object-cover opacity-100"
              />
            </div>
          </div>
        </div>
      </FadeIn>

      {/* Bottom Section: Footer Metadata */}
      <div className="max-w-7xl mx-auto w-full grid grid-cols-1 md:grid-cols-2 gap-4 items-end text-[11px] text-zinc-500 pt-4 border-t border-zinc-200">
        <address className="not-italic leading-relaxed space-y-0.5">
          <span className="font-bold text-brand-navy text-[10px] uppercase tracking-wider block mb-0.5">{t("contact.address")}</span>
          <div className="text-zinc-600">{t("contact.street")}, {t("contact.city")}, {t("contact.country")}</div>
          <span className="text-zinc-400 text-[10px] block">{t("contact.cvr")}</span>
        </address>

        <div className="md:text-right text-left text-zinc-400 font-bold uppercase tracking-wider text-[9px]">
          {t("footer.presentedBy")}
        </div>
      </div>
    </section>
  );
}
